import { render, staticRenderFns } from "./EditTextArea.vue?vue&type=template&id=1585041a"
import script from "./EditTextArea.vue?vue&type=script&lang=js"
export * from "./EditTextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports